import * as actions from '../models/actions/names';
import {
  UserChangedInputTextAction,
  ParaphraserReceivedGrammarCheckDataAction,
  HasGrammarErrorAction,
} from '../models/actions';
import { ParaphraseGrammarCheckData } from '../models/GrammarCheck';

export const changeInputTextAction = (
  inputHTML: string,
  inputText: string,
  wordCount: number,
  charCount: number
): UserChangedInputTextAction => ({
  type: actions.USER_CHANGED_INPUT_TEXT,
  payload: {
    inputHTML,
    inputText,
    wordCount,
    charCount,
  },
});

export const setGrammarErrorAction = (numberOfErrors: number): HasGrammarErrorAction => ({
  type: actions.HAS_GRAMMAR_ERROR,
  payload: {
    numberOfErrors,
  },
});

export const paraphraserRecievedGrammarCheckDataAction = (
  value: ParaphraseGrammarCheckData
): ParaphraserReceivedGrammarCheckDataAction => ({
  type: actions.PARAPHRASER_RECEIVED_GRAMMAR_CHECK_DATA,
  payload: {
    value,
  },
});
